module.exports = __webpack_public_path__ + "0b746f8a9294b83898ece3347ae5c619.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/consult/consult-pic.png
// module id = 722
// module chunks = 0